import React, { useEffect, useState, useContext} from 'react'
import '../../styles/CommunityEventsUI.css';
import { useSearchParams } from 'react-router-dom';
import { UserContext } from '../UserContext';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router-dom";
import EventsPopUI from './EventsPopUI';
import TrophiesAndCountMob from '../MobUI/TrophiesAndCountMob';

const CommunityEventsUI = () => {
const [openEvents,setOpenEvents] = useState(false)
const {user} = useContext(UserContext)
const [events,setEvents] = useState([]);

useEffect(()=>{
	if(user){
		getEvents()
	}
	
},[user])

//get comunity
const getEvents = ()=>{

    let apiURL=process.env.REACT_APP_API_URL + "/events/getallevents"; 

    fetch(apiURL)
    .then((res)=> (res.status===200 ? res.json() : res.text()))
    .then((repos)=> {
        if (repos.data) {
         
          setEvents(repos.data);
        }else alert(repos.message || repos);  
    }) 
    .catch((err) => alert(err));
  }

  return (

   <div id="down_grp_com_pc_event">
		<svg class="bg_com_event_page_pc_for_cards_">
			<linearGradient id="bg_com_event_page_pc_for_cards_" spreadMethod="pad" x1="1.142" x2="0.009" y1="1.187" y2="0">
				<stop offset="0" stop-color="#40e196" stop-opacity="1"></stop>
				<stop offset="1" stop-color="#fff" stop-opacity="1"></stop>
			</linearGradient>
			<rect id="bg_com_event_page_pc_for_cards_" rx="20" ry="20" x="0" y="0" width="100%" height="100%">
			</rect>
		</svg>
		<div id="recent_com_pc_event">
			<svg class="recent_events_line_com_events_pc" viewBox="0 0 5 26">
				<path id="recent_events_line_com_events_pc" d="M 0 0 L 0 26">
				</path>
			</svg>
			<div id="recent_events_new_events_page_">
				<span>Events</span>
			</div>
			<div style={{position:"absolute",width:"100%", left:"0px",top:"40px",display:"flex",flexWrap:"wrap"}}>
			{events.filter(rec=>rec.organiserId!==user._id).map((eve)=>(
			<div id="recent_event_card_1_com_pc_eve">

				<svg class="all_card_borer_v_com_pc_event">
					<rect id="all_card_borer_v_com_pc_event" rx="10" ry="10" x="0" y="0" width="326" height="349">
					</rect>
				</svg>
				<div id="By_by_vent_com_pc_event">
					<span>By</span>
				</div>
				<div id="Son_Goku_lbl_com_pc_event">
					<span>{eve.organiserName}</span>
				</div>
				<div id="Comic_Con_Bangalore_-_2023_vco">
					<span>{eve.title}</span>
				</div>
				<img id="img_logo_com_pc_event" src={eve.organiserImageId?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+eve.organiserImageId:"./MyPortfolio/Events/img_logo_com_pc_event.png"} />
					
				<img id="idk_ventcom_pc_event" src={eve.eventImageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+eve.eventImageUrl.split('/')[5]:"./MyPortfolio/Events/idk_ventcom_pc_event.png"} />
					
				<svg class="img_bdrcom_pc_event">
					<rect id="img_bdrcom_pc_event" rx="8" ry="8" x="0" y="0" width="286.24" height="159">
					</rect>
				</svg>
				<svg class="amount_bdr_com_pc_event">
					<rect id="amount_bdr_com_pc_event" rx="5" ry="5" x="0" y="0" width="73" height="31">
					</rect>
				</svg>
				<div id="n_1139_vent_com_pc_event">
					<span>{eve.cost}</span>
				</div>
				<svg class="bdr_trophie_v_com_pc_event">
					<rect id="bdr_trophie_v_com_pc_event" rx="5" ry="5" x="0" y="0" width="73" height="31">
					</rect>
				</svg>
				<div id="from_to_grp_com_pc_event">
					<div id="Fromcom_pc_event">
						<span>From</span>
					</div>
					<div id="n_3th_Jan_2023_vent_com_pc_eve">
						<span>{eve.startsOn.slice(0,10)} - {eve.startsOn.slice(11,16)}</span>
					</div>
					<svg class="cal_64_com_pc_event">
						<ellipse id="cal_64_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_8h_com_pc_event">
						<ellipse id="cal_8h_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_87_com_pc_event">
						<ellipse id="cal_87_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_57_com_pc_event">
						<ellipse id="cal_57_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_r54_com_pc_event">
						<ellipse id="cal_r54_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_ourter_com_pc_event">
						<ellipse id="cal_ourter_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_6_com_pc_event" viewBox="0 0 17 17">
						<path id="cal_6_com_pc_event" d="M 16.3359375 11.6875 C 16.70269966125488 11.6875 17 11.39019870758057 17 11.0234375 L 17 3.984375238418579 C 17 2.519718647003174 15.80840587615967 1.328125 14.34375 1.328125 L 13.48046875 1.328125 L 13.48046875 0.6640625 C 13.48046875 0.297300785779953 13.18316745758057 0 12.81640625 0 C 12.44964504241943 0 12.15234375 0.297300785779953 12.15234375 0.6640625 L 12.15234375 1.328125 L 9.130859375 1.328125 L 9.130859375 0.6640625 C 9.130859375 0.297300785779953 8.833558082580566 0 8.466796875 0 C 8.100035667419434 0 7.802734851837158 0.297300785779953 7.802734851837158 0.6640625 L 7.802734851837158 1.328125 L 4.814453125 1.328125 L 4.814453125 0.6640625 C 4.814453125 0.297300785779953 4.517152309417725 0 4.150390625 0 C 3.783628702163696 0 3.486328125 0.297300785779953 3.486328125 0.6640625 L 3.486328125 1.328125 L 2.65625 1.328125 C 1.191593766212463 1.328125 0 2.519718647003174 0 3.984375238418579 L 0 14.34375 C 0 15.80840587615967 1.191593766212463 17 2.65625 17 L 14.34375 17 C 15.80840587615967 17 17 15.80840587615967 17 14.34375 C 17 13.97698879241943 16.70269966125488 13.6796875 16.3359375 13.6796875 C 15.96917629241943 13.6796875 15.67187595367432 13.97698879241943 15.67187595367432 14.34375 C 15.67187595367432 15.07607841491699 15.07607841491699 15.67187595367432 14.34375 15.67187595367432 L 2.65625 15.67187595367432 C 1.923921704292297 15.67187595367432 1.328125 15.07607841491699 1.328125 14.34375 L 1.328125 3.984375238418579 C 1.328125 3.252046585083008 1.923921704292297 2.65625 2.65625 2.65625 L 3.486328125 2.65625 L 3.486328125 3.3203125 C 3.486328125 3.687074184417725 3.783628702163696 3.984375238418579 4.150390625 3.984375238418579 C 4.517151832580566 3.984375238418579 4.814453125 3.687074184417725 4.814453125 3.3203125 L 4.814453125 2.65625 L 7.802734851837158 2.65625 L 7.802734851837158 3.3203125 C 7.802734851837158 3.687074184417725 8.100034713745117 3.984375238418579 8.466796875 3.984375238418579 C 8.833558082580566 3.984375238418579 9.130859375 3.687074184417725 9.130859375 3.3203125 L 9.130859375 2.65625 L 12.15234375 2.65625 L 12.15234375 3.3203125 C 12.15234375 3.687074184417725 12.44964504241943 3.984375238418579 12.81640625 3.984375238418579 C 13.18316745758057 3.984375238418579 13.48046875 3.687074184417725 13.48046875 3.3203125 L 13.48046875 2.65625 L 14.34375 2.65625 C 15.07607841491699 2.65625 15.67187595367432 3.252046585083008 15.67187595367432 3.984375238418579 L 15.67187595367432 11.0234375 C 15.67187595367432 11.39019870758057 15.96917629241943 11.6875 16.3359375 11.6875 Z">
						</path>
					</svg>
					<svg class="cal_6_com_pc_event_bt">
						<ellipse id="cal_6_com_pc_event_bt" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_5_ecom_pc_event">
						<ellipse id="cal_5_ecom_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_4com_pc_event">
						<ellipse id="cal_4com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_3_com_pc_event">
						<ellipse id="cal_3_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_2_com_pc_event">
						<ellipse id="cal_2_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<svg class="cal_1_com_pc_event">
						<ellipse id="cal_1_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
						</ellipse>
					</svg>
					<div id="To_lbl_com_pc_event">
						<span>To</span>
					</div>
					<div id="date_tocom_pc_event">
						<span>{eve.endsOn.slice(0,10)} - {eve.endsOn.slice(11,16)}</span>
					</div>
				</div>

				{/* <svg class="signal_com_pc_event">
					<ellipse id="signal_com_pc_event" rx="3.096630334854126" ry="3.096630334854126" cx="3.096630334854126" cy="3.096630334854126">
					</ellipse>
				</svg>
				<div id="Online_Event_lbl_com_pc_event">
					<span>Online Event</span>
				</div> */}

				{/* <img id="trophy_img_com_pc_event" src="./MyPortfolio/Events/trophy_img_com_pc_event.png" srcset="./MyPortfolio/Events/trophy_img_com_pc_event.png 1x" />
					
				<div id="n_234_com_com_pc_event">
					<span>1234</span>
				</div> */}

				<div id='trophy_img_com_pc_event'>
					<TrophiesAndCountMob portfolioType={"events"} portfolioId={eve._id}/>
					</div>

				<svg class="share_bdrevent_new_pc_com_pc_e">
					<ellipse id="share_bdrevent_new_pc_com_pc_e" rx="18.955787658691406" ry="19" cx="18.955787658691406" cy="19">
					</ellipse>
				</svg>
				<img id="share_com_pc_event" src="./MyPortfolio/Events/share_com_pc_event.png" srcset="./MyPortfolio/Events/share_com_pc_event.png 1x" />
					
			</div>
			))}
			</div>
		</div>
	
    </div>
  )
}

export default CommunityEventsUI
